import {
  AfterViewInit,
  Directive,
  EmbeddedViewRef,
  Input,
  Renderer2,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';

@Directive({
  selector: '[applyHeight]',
  standalone: true
})
export class ApplyHeightDirective implements AfterViewInit {
  @Input('applyHeight') containerRef!: HTMLElement;
  @Input() factor: number = 1.5 // Factor to adjust height, default is 1.5

  private viewRef!: EmbeddedViewRef<any>;
  private observer?: ResizeObserver

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private renderer: Renderer2
  ) {
  }

  @Input()
  set applyHeight(ref: HTMLElement) {
    this.containerRef = ref;
    this.viewContainer.clear();
    this.viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
    this.viewRef.detectChanges();

    // Delay to ensure DOM is ready
    setTimeout(() => {
      this.syncHeight();
    });
  }

  ngAfterViewInit() {
    // Delay to ensure view is rendered
    setTimeout(() => {
      this.syncHeight();
    });
  }

  private syncHeight() {
    if (this.containerRef && this.viewRef && this.viewRef.rootNodes.length) {
      const absChild = this.viewRef.rootNodes[0] as HTMLElement;
      if (absChild) {
        this.observer?.disconnect();
        this.observer = new ResizeObserver(() => {
          const targetHeight = absChild.offsetHeight * this.factor;
          const currentHeight = this.containerRef.offsetHeight;

          // Only increase height, never decrease
          if (targetHeight > currentHeight) {
            this.renderer.setStyle(this.containerRef, 'height', targetHeight + 'px');
          }
          // Else: do nothing, keep the bigger height
        });
        this.observer.observe(absChild);
      }
    }
  }

}
